import { Card } from 'primereact/card';
import { useRouteError } from 'react-router-dom';

function ErrorPage() {
    const error = useRouteError();

    return (
        <Card title="Whoa!" subTitle="Something unexpected happened" className="pageCard">
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
        </Card>
    );
}

export default ErrorPage;
